import $ from 'jquery';
import mediator from './mediator'; // check if browser is Internet Explorer

var isIE =
/* @cc_on!@ */
false || !!document.documentMode;
var spacing = 16;

var setAnimatedElPos = function setAnimatedElPos() {
  if (!isIE) {
    $('.pinned-block-image').each(function (i, el) {
      var breakpoint = window.cigna.screen.breakpoint;
      var imageCol = $(el).closest('.col-12');
      var imageRow = $(el).closest('.row');
      var isRightBlock = $(imageCol).offset().left > document.documentElement.clientWidth / 2;
      var isRightSixSixBlock = $(imageCol).hasClass('col-md-6') && $(imageCol).next().length === 0;

      if (!['xs', 'sm'].includes(breakpoint)) {
        $(el).removeClass('animate__fadeInRight');
        $(el).removeClass('animate__fadeInLeft');
        $(el).removeClass('animation-delay');

        if (isRightBlock || isRightSixSixBlock) {
          $(el).css({
            left: '100px',
            width: "".concat(document.documentElement.clientWidth - imageCol.offset().left - spacing, "px")
          });
        } else {
          var blockRect = imageRow[0].getBoundingClientRect();
          $(el).css({
            width: imageCol.outerWidth() + imageCol.offset().left - spacing - 100,
            left: -(blockRect.left + spacing)
          });
          $($(el)).find('.pinned-image-bg').css({
            'background-position': 'top right'
          });
        }
      }
    });
  }
};

export var initialPinImage = function initialPinImage() {
  $('.pinned-block-image').each(function (index, el) {
    if (!isIE) {
      var $el = $(el);
      var imageCol = $el.closest('.col-12');
      var imageRow = $el.closest('.row');
      var isRightBlock = $(imageCol).offset().left > document.documentElement.clientWidth / 2;
      var isRightSixSixBlock = $(imageCol).hasClass('col-md-6') && $(imageCol).next().length === 0;
      var topOfEl = $el.offset().top;
      var bottomOfEl = topOfEl + $el.outerHeight();
      var bottomOfView = $(window).scrollTop() + $(window).innerHeight();
      var topOfView = $(window).scrollTop();
      var breakpoint = window.cigna.screen.breakpoint;
      var fadeClass = 'animate__fadeInRight';

      if (!['xs', 'sm', 'md'].includes(breakpoint)) {
        if (isRightBlock || isRightSixSixBlock) {
          $(el).css({
            width: document.documentElement.clientWidth - imageCol.offset().left - spacing + 100,
            left: 0
          });
        } else {
          fadeClass = 'animate__fadeInLeft';
          var blockRect = imageRow[0].getBoundingClientRect();
          $el.css({
            width: imageCol.outerWidth() + imageCol.offset().left - spacing,
            left: -(blockRect.left + spacing)
          });
        }

        if (topOfView > bottomOfEl) {
          $el.addClass('no-animate');
        }

        if (bottomOfView > topOfEl && topOfView < topOfEl) {
          if (!$(el).hasClass(fadeClass) && !$(el).hasClass('no-animate')) {
            $('body').css({
              'overflow-x': 'hidden'
            });
            $(el).addClass(fadeClass);
          }
        }
      } else {
        $(el).removeClass('animation-delay').removeClass('animate__animated');
      }
    } else {
      $(el).removeClass('animation-delay').removeClass('animate__animated');
    }
  });
};
export default (function () {
  setAnimatedElPos();
  initialPinImage();
  $(window).on('scroll', function () {
    initialPinImage();
  });
  mediator.on('window:throttledResize', initialPinImage);
});